export default "__VITE_ASSET__CYCJcOE0__"